module.exports = __webpack_public_path__ + "static/media/modus-logo.b15190dd.svg";